<template>
  <div>
    <div class="form-row">
      <!--<div class="form-group col-md-2">
        <label for="">地點名稱</label>
        <input type="text" class="form-control" v-model="location">
      </div>
      <div class="form-group col-md-2">
        <label for="">地點代碼</label>
        <input type="text" class="form-control" v-model="location_code">
      </div>-->
      <div class="form-group col-md-2">
        <label for="">道路限速</label>
        <input type="text" class="form-control" v-model="road_speed_limit">
      </div>
      <div class="form-group col-md-2">
        <label for="">舉發車速(超速)</label>
        <input type="text" class="form-control" v-model="break_value">
      </div>
      <div class="form-group col-md-2">
        <label for="">舉發車速(龜速)</label>
        <input type="text" class="form-control" v-model="break_value_slow">
      </div>
      <div class="form-group col-md-2">
        <label for="">警示違規車速</label>
        <input type="text" class="form-control" v-model="alarmSpeed">
      </div>
      <div class="form-group col-md-2">
        <label for="">警示違規筆數</label>
        <input type="text" class="form-control" v-model="alarmIllegalNum">
      </div>
    </div>
    <div class="form-row">
      <button class="btn btn-primary" @click="updatePara">更新</button>
    </div>
  </div>
</template>

<script>
import { systemType } from '@/config';
import PasswordChange from '@/components/common/PasswordChange';
import Confirm from '@/components/common/Confirm';

export default {
  name: 'ParaDetail',
  data() {
    return {
      //location: null,
      //location_code: null,
      road_speed_limit: 0,
      break_value: 0,
      break_value_slow: 0,
      alarmSpeed: 0,
      alarmIllegalNum: 0,
    };
  },
  props: {
    rowData: {
      type: Object,
      required: true,
    },
    rowIndex: {
      type: Number,
    },
  },
  components: {
    PasswordChange,
    Confirm,
  },
  async created() {
    //this.location = this.rowData.location;
    //this.location_code = this.rowData.location_code;
    this.road_speed_limit = this.rowData.road_speed_limit;
    this.break_value = this.rowData.break_value;
    this.break_value_slow = this.rowData.break_value_slow;
    this.alarmSpeed = this.rowData.alarmSpeed;
    this.alarmIllegalNum = this.rowData.alarmIllegalNum;
  },
  computed: {
    instance() {
      return this.$store.state.instance;
    },
  },
  methods: {
    updatePara() {
      this.instance.patch(`/api/fixed-link-code/${this.rowData.id}/`, {
        //location: this.location,
        //location_code: this.location_code,
        road_speed_limit: this.road_speed_limit,
        break_value: this.break_value,
        break_value_slow: this.break_value_slow,
        alarmSpeed: this.alarmSpeed,
        alarmIllegalNum: this.alarmIllegalNum,
      })
      .then(() => {
        this.$parent.refresh();
        this.$store.commit('SET_MESSAGE', {
          type: 'success',
          context: '更新成功',
        });
        this.$parent.refresh();
      })
      .catch((err) => {
        this.$store.commit('SET_MESSAGE', {
          type: 'error',
          context: err.response.data,
        });
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// ParaDetail.vue?89480454